import React from 'react';
import {WorkQueueItem} from 'ApplicationEntry/models/WorkQueueItem';
import {Typography} from '@material-ui/core';

type DisplayPolicyNumberProps = {
  workQueueItemList?: WorkQueueItem;
  isQuality: boolean;
};

const DisplayPolicyNumber = (props: DisplayPolicyNumberProps) => {
  return (
    <>
      {!props.isQuality && (
        <div className="awdStatus-section__title-container">
          <Typography variant="subtitle1" className="awdStatus-section__title-container-title">
            Policy Number : {props.workQueueItemList?.policyNumber}
          </Typography>
        </div>
      )}
    </>
  );
};
export default DisplayPolicyNumber;
